<script setup>
import { onMounted, ref } from 'vue';
import { register } from 'swiper/element/bundle';
import axios from 'axios';

import BannerPost from '@/views/feed/Banner.vue';

register();

const swiper = ref();
const banners = ref([]);

const getBanner = async () => {
  try {
    const response = await axios.get(`/api/banner`);
    const data = response.data.data;
    if (!data || !Array.isArray(data)) return;

    banners.value = data;
} catch (error) {
    console.error("Failed to fetch banner:", error);
}
};

onMounted(() => {
  getBanner();
});
</script>

<template>
  <div v-if="banners.length" class="w-full my-5">
    <swiper-container
        ref="swiper"
        class="w-full min-[150px]"
        space-between="10"
        slides-per-view="1.2"
        autoplay-delay="10000"
    >
      <swiper-slide v-for="banner in banners" :key="banner.id">
        <BannerPost :banner="banner" />
      </swiper-slide>
    </swiper-container>
  </div>
</template>
